export default __webpack_public_path__ + "static/media/call_missed.ba8ae881.svg";